<template>
    <div class="main-div">
      <div class="title-div">
        <span>No Deletion Guide Found</span>
        <p>We're actively working on a guide for this company. Check back soon!</p>
      </div>
    </div>
</template>
<script setup lang="ts">

</script>
<style lang="scss" scoped>
.main-div {
    @apply h-screen flex flex-col justify-start items-center pb-5 pt-10 px-6 bg-gray-50/50;
}
.title-div {
    @apply flex flex-col items-center gap-1 self-stretch;

    span {
        @apply self-stretch text-gray-900 text-center font-semibold text-base leading-6;
    }
    p {
        @apply text-gray-600 text-center text-sm font-normal leading-5 max-w-sm mb-3;
    }
}
</style>